<div class="card-body">
    <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if="messError">
        <span>{{ messError }}</span>
        <button type="button" class="close" data-dismiss="alert" aria-label="Close" @click="removeError">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="col-sm-12 d-flex justify-content-between mt-4">
        <div class="action d-flex align-items-center gap-3">
            <div class="total">
                {{ CommonText.TOTAL_RECORD(listDataProduct.length, paginate.itemCount) }}
            </div>
            <div class="dropdown-action">
                <SelectNormal
                        :label="selectAction.label"
                        :id="selectAction.id"
                        :placeholder="selectAction.placeholder"
                        :value-default="selectAction.value"
                        @inputValue="onChangeAction($event)"
                        :required="selectAction.required"
                        :options="selectAction.options"
                ></SelectNormal>
            </div>
        </div>
        <div class="d-flex align-items-center gap-2">
            <span>Hiển thị</span>
            <SelectNormal
                    :label="selectLimit.label"
                    :id="selectLimit.id"
                    :placeholder="selectLimit.placeholder"
                    :value-default="selectLimit.value"
                    @inputValue="onChangeLimit($event)"
                    :required="selectLimit.required"
                    :options="selectLimit.options"
            >
            </SelectNormal>
            <span> kết quả trên trang</span>
        </div>
    </div>
    <div class="list-product-component">
        <table class="table">
            <thead>
            <tr>
                <th>
                    <InputCheckboxOne id="select_all" :value-default="checkAll" @inputValue="onChangeSelectAll($event)"
                                      :checked="checkAll"></InputCheckboxOne>
                </th>
                <th class="text-center" scope="col" v-for="header in dataHeaderTable" :key="header.order"
                    :style="{ 'width': header.width }" v-html="header.label"></th>
            </tr>
            </thead>
            <tbody>
            <tr v-if="listDataProduct.length > 0" v-for="product in listDataProduct" :key="product.id">
                <td>
                    <InputCheckboxOne :id="product.id" :value-default="!!checkItems[product.id]"
                                      @inputValue="onChangeSelectItem($event, product.id)"
                                      :checked="!!checkItems[product.id]"></InputCheckboxOne>
                </td>
                <td class="text-center">{{ product.product_name }}</td>
                <td class="text-center">{{ product.product_code }}</td>
                <td class="text-center">{{ product.product_quantity }}</td>
                <td class="text-center">{{ CommonService.formatPrice(product.product_price, 'VND') }}</td>
                <td class="text-center">{{ product.product_unit }}</td>
                <td class="text-center">{{ CommonService.formatDate(product.created_at) }}</td>
            </tr>
            <tr v-else>
                <td colspan="9" class="text-center">Không có dữ lệu được tìm thấy!</td>
            </tr>
            </tbody>
        </table>
    </div>
    <PaginateComponent :paginate="paginate" :urlOrigin="urlOrigin" @page="emitPage($event)"
                       v-if="paginate.itemCount > paginate.take"></PaginateComponent>
</div>

<ModalWarehouseListComponent
        @showModalWarehouse="showModalWarehouse($event)"
        @searchWarehouse="eventSearchWarehouse($event)"
        @listWarehousesSelectedCurrent="syncSelectedKiotvietProducts($event)"
        :eventClickShowModal="eventClickShowModalWarehouse"
        :listWarehousesSelected="listWarehousesSelected"
        :typeSelectItem="typeSelectWarehouse"
></ModalWarehouseListComponent>
